import {
  GET_INITIAL_STATE,
  SELECT_PAY_ELEMENT,
  SET_OVERALL_COMPOSITE_JOB,
  GET_OVERALL_COMPOSITE_SUCCESS,
  RESET_OVERALL_COMPOSITE,
  SET_SELECTED_YEAR_OVER_YEAR_DATA,
  SET_YEAR_OVER_YEAR_DISPLAY_IN,
  SET_YEAR_OVER_YEAR_BENCHMARK_YEAR,
  TOGGLE_SHOW_AS_PERCENTAGE,
  SHOW_OVERALL_COMPOSITES,
  SHOW_SURVEY_JOB_MATCHES,
  GET_SURVEY_JOB_MATCHES_SUCCESS,
  GET_SURVEY_JOB_MATCHES_START,
  GET_SURVEY_JOB_MATCHES_ERROR,
  SHOW_SURVEY_JOB_DRILLDOWN,
  YEAR_OVER_YEAR_PRINT_START,
  YEAR_OVER_YEAR_PRINT_SUCCESS,
  YEAR_OVER_YEAR_PRINT_ERROR,
  RESET_YEAR_OVER_YEAR_ERRORS
} from './YearOverYearActions';

import { DISPLAY_IN_TYPE } from '../../lib/displayIn';

const BASE_PAY = 'baseSalary';
const TOTAL_CASH = 'totalCash';
const TOTAL_TARGET_CASH = 'totalTargetCash';
const TOTAL_DIRECT = 'totalDirect';
const TOTAL_GUARANTEED_PAY = 'totalGuaranteedPay';

// TODO: These will be removed upon hooking up with the acs page
const composite1 = {
  baseSalary: {
    targetElement: '50th',
    currentYear: { label: 2017, value: 69948.09 },
    prevYear: { label: 2016, value: null },
    prevPrevYear: { label: 2015, value: 61283.12 }
  },
  totalCash: {
    targetElement: '50th',
    currentYear: { label: 2017, value: 71807.24 },
    prevYear: { label: 2016, value: null },
    prevPrevYear: { label: 2015, value: 63256.77 }
  },
  totalTargetCash: {
    targetElement: '50th',
    currentYear: { label: 2017, value: 72844.16 },
    prevYear: { label: 2016, value: null },
    prevPrevYear: { label: 2015, value: 63548.39 }
  },
  totalDirect: {
    targetElement: '50th',
    currentYear: { label: 2017, value: 71858.49 },
    prevYear: { label: 2016, value: null },
    prevPrevYear: { label: 2015, value: 63254 }
  },
  totalGuaranteedPay: {
    targetElement: '50th',
    currentYear: { label: 2017, value: 69881.54 },
    prevYear: { label: 2016, value: null },
    prevPrevYear: { label: 2015, value: 0 }
  }
};

const composite2 = {
  baseSalary: {
    targetElement: 'avg',
    currentYear: { label: 2017, value: 47809.01 },
    prevYear: { label: 2016, value: 49137.32 },
    prevPrevYear: { label: 2015, value: null }
  },
  totalCash: {
    targetElement: '25th',
    currentYear: { label: 2017, value: 42173.31 },
    prevYear: { label: 2016, value: 43345.04 },
    prevPrevYear: { label: 2015, value: null }
  },
  totalTargetCash: {
    targetElement: '75th',
    currentYear: { label: 2017, value: 56922.6 },
    prevYear: { label: 2016, value: 58504.11 },
    prevPrevYear: { label: 2015, value: null }
  },
  totalDirect: {
    targetElement: '90th',
    currentYear: { label: 2017, value: null },
    prevYear: { label: 2016, value: null },
    prevPrevYear: { label: 2015, value: null }
  },
  totalGuaranteedPay: {
    targetElement: '60th',
    currentYear: { label: 2017, value: null },
    prevYear: { label: 2016, value: null },
    prevPrevYear: { label: 2015, value: null }
  }
};

const initialState = {
  overallComposite: composite1,
  isCompositeLoading: true,
  selectedPayElement: BASE_PAY,
  selectedJobId: null,
  selectedBenchmarkYear: null,
  selectedOrgJob: {},
  hideJobCodeKey: false,
  jobCodeKeyText: 'Job Code Key',
  showAsPercentage: false,
  showOverallComposites: true,
  surveyJobMatches: [],
  isSurveyJobMatchesLoading: false,
  errorLoadingSurveyJobMatches: false,
  showSurveyJobDrilldown: false,
  drilldownJob: {},
  monetaryRounding: 2,
  percentRounding: 1,
  displayIn: DISPLAY_IN_TYPE.ANNUAL,
  isPrinting: false,
  printError: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_INITIAL_STATE:
      return {
        ...state,
        isCompositeLoading: false
      };
    case SELECT_PAY_ELEMENT: {
      return {
        ...state,
        selectedPayElement: action.payElement
      };
    }
    case SET_OVERALL_COMPOSITE_JOB:
      return {
        ...state,
        selectedOrgJob: action.data
      };
    case GET_OVERALL_COMPOSITE_SUCCESS:
      // TODO check for failures
      return {
        ...state,
        overallComposite: action.data.overallComposite,
        percentRounding: action.data.overallComposite.percentRounding,
        monetaryRounding: action.data.overallComposite.monetaryRounding,
        isCompositeLoading: false
      };
    case RESET_OVERALL_COMPOSITE:
      return {
        ...state,
        selectedPayElement: BASE_PAY,
        selectedOrgJob: {},
        selectedJobId: null,
        overallComposite: null,
        showOverallComposites: true,
        surveyJobMatches: []
      };
    case SET_SELECTED_YEAR_OVER_YEAR_DATA:
      return {
        ...state,
        selectedJobId: action.orgJobId,
        selectedBenchmarkYear: action.benchmarkYear,
        selectedPayElement: BASE_PAY,
        selectedOrgJob: {},
        hideJobCodeKey: action.hideJobCodeKey,
        jobCodeKeyText: action.jobCodeKeyText,
        overallComposite: null,
        showOverallComposites: true,
        surveyJobMatches: []
      };
    case SET_YEAR_OVER_YEAR_DISPLAY_IN: {
      const displayIn = action.displayIn;
      return {
        ...state,
        displayIn
      };
    }
    case SET_YEAR_OVER_YEAR_BENCHMARK_YEAR: {
      const benchmarkYear = action.benchmarkYear;
      return {
        ...state,
        selectedBenchmarkYear: benchmarkYear
      };
    }
    case YEAR_OVER_YEAR_PRINT_START: {
      return {
        ...state,
        isPrinting: true,
        printError: false
      };
    }
    case YEAR_OVER_YEAR_PRINT_SUCCESS: {
      return {
        ...state,
        isPrinting: false,
        printError: false
      };
    }
    case YEAR_OVER_YEAR_PRINT_ERROR: {
      return {
        ...state,
        isPrinting: false,
        printError: true
      };
    }
    case RESET_YEAR_OVER_YEAR_ERRORS: {
      return {
        ...state,
        printError: false,
        isPrinting: false
      };
    }
    case TOGGLE_SHOW_AS_PERCENTAGE:
      return {
        ...state,
        showAsPercentage: !state.showAsPercentage
      };
    case SHOW_OVERALL_COMPOSITES:
      return {
        ...state,
        showOverallComposites: true
      };
    case SHOW_SURVEY_JOB_MATCHES:
      return {
        ...state,
        showOverallComposites: false,
        showSurveyJobDrilldown: false
      };
    case GET_SURVEY_JOB_MATCHES_SUCCESS: {
      if (action.data.success) {
        return {
          ...state,
          isSurveyJobMatchesLoading: false,
          surveyJobMatches: action.data.surveyJobMatches
        };
      } else {
        return {
          ...state,
          isSurveyJobMatchesLoading: false,
          surveyJobMatches: [],
          errorLoadingSurveyJobMatches: true
        };
      }
    }
    case GET_SURVEY_JOB_MATCHES_START:
      return {
        ...state,
        isSurveyJobMatchesLoading: true,
        errorLoadingSurveyJobMatches: false
      };
    case GET_SURVEY_JOB_MATCHES_ERROR:
      return {
        ...state,
        isSurveyJobMatchesLoading: false,
        errorLoadingSurveyJobMatches: true
      };
    case SHOW_SURVEY_JOB_DRILLDOWN:
      return {
        ...state,
        showSurveyJobDrilldown: true,
        drilldownJob: action.data
      };
    default:
      return state;
  }
}
